/**
 * Single place to configure the real generation backend. Nothing sensitive
 * lives here — this is a public backend URL, safe to ship to the browser.
 * The actual Tripo API key stays exclusively on the backend (Vercel).
 *
 * MODE:
 *   'real' — talks to PRENDFORM_API_BASE (presign/upload/generate/status).
 *   'demo' — local simulated progress, no network calls (see
 *            generation-engine.js's DEMO branch). Useful for design/dev.
 *
 * To switch modes, change MODE here only — no other file needs editing.
 */
window.PfGenerationConfig = {
  API_BASE: 'https://prendforme-tripo-api.vercel.app',
  MODE: 'real',
  DEBUG: true,
};
